import * as React from "react";
import type { SVGProps } from "react";
const SvgBulletList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.29 6.71c.19.18.45.29.71.29.062 0 .116-.008.177-.017L3.2 6.98q.09-.015.18-.06.09-.03.18-.09c.033-.02.067-.049.1-.078l.05-.042c.09-.1.16-.2.21-.33.06-.12.08-.25.08-.38s-.02-.26-.08-.38q-.075-.18-.21-.33l-.15-.12a.8.8 0 0 0-.18-.09.6.6 0 0 0-.18-.06c-.33-.07-.67.04-.91.27q-.135.15-.21.33C2.02 5.74 2 5.87 2 6s.02.26.08.38c.05.13.12.23.21.33M7 7h14c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1M7 13h14c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1M21 19H7c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1M3 13c-.26 0-.52-.11-.71-.29-.09-.1-.16-.2-.21-.33A.84.84 0 0 1 2 12c0-.13.02-.26.08-.38q.075-.18.21-.33c.24-.23.58-.34.91-.27q.09.015.18.06.09.03.18.09l.15.12q.135.15.21.33c.06.12.08.25.08.38s-.02.26-.08.38c-.05.13-.12.23-.21.33l-.05.042a.757.757 0 0 1-.28.168q-.09.045-.18.06l-.023.003c-.06.01-.115.017-.177.017M2.29 18.71c.19.18.45.29.71.29.062 0 .116-.008.177-.017l.023-.003q.09-.015.18-.06a.8.8 0 0 0 .28-.168l.05-.042c.09-.1.16-.2.21-.33.06-.12.08-.25.08-.38s-.02-.26-.08-.38q-.075-.18-.21-.33l-.15-.12a.8.8 0 0 0-.18-.09.6.6 0 0 0-.18-.06c-.33-.07-.67.04-.91.27q-.135.15-.21.33c-.06.12-.08.25-.08.38s.02.26.08.38c.05.13.12.23.21.33"
    />
  </svg>
);
export default SvgBulletList;
